import { render, staticRenderFns } from "./DiceSelect.vue?vue&type=template&id=b6539bd4&lang=pug&"
import script from "./DiceSelect.vue?vue&type=script&lang=js&"
export * from "./DiceSelect.vue?vue&type=script&lang=js&"
import style0 from "./DiceSelect.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DiceSelect.vue"
export default component.exports